export {WsTab} from './ws-tab.js';
export {WsTabPanel} from './ws-tab-panel.js';
export {WsTabs} from './ws-tabs.js';
export type {WsTabsOrientation, WsTabsVariant} from './ws-tabs.js';
